<template>
    <div class="min-h-screen flex items-center justify-center">
        <div class="card-secondary max-w-lg mx-2 p-6 space-y-4">
            <p v-if="loading">Activation en cours...</p>
            <p v-else>{{ message }}</p>
            <router-link v-if="!loading" :to="{ name: 'LoginRegister', query: { view: 'login' } }"
                class="text-gold block text-center mt-4">
                Retour à la connexion
            </router-link>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

const API_BASE_URL = (process.env.VUE_APP_API_URL || '/api').replace(/\/$/, '')

export default {
    data() {
        return {
            message: '',
            loading: true
        }
    },
    async mounted() {
        const token = this.$route.query.token
        if (!token) {
            this.message = 'Lien invalide'
            this.loading = false
            return
        }

        try {
            const response = await axios.get(`${API_BASE_URL}/auth/activate`, {
                params: { token },
                withCredentials: true
            })
            this.message = response.data.message
        } catch (err) {
            this.message = err.response?.data?.message || 'Erreur lors de l’activation'
        } finally {
            this.loading = false
        }
    }
}
</script>
